import React from 'react';

export default class AdComponent extends React.Component {
  componentDidMount () {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }

render () {
    return (
      <ins className="adsbygoogle"
      style={{ display: 'block' }}
      data-ad-client="ca-pub-5689039165823791"
      data-ad-slot="3474227185"
      data-ad-format="auto"></ins>
    );
  }
}



// WEBPACK FOOTER //
// ./src/AdComponent.jsx